import React, { useContext } from 'react'
import Avatar from '../../components/avatars/Avatar'
import { useNavigate } from 'react-router-dom'
import { getUser, upsertAvatar } from '../../api/supabaseApi'
import { AuthContext } from '../../context/AuthContext'
import useApi from '../../hooks/useApi'
import LoadingOverlay from '../../components/common/LoadingOverlay'
import { fetchToken } from '../../api/readyPlayerApi'

const AvatarCreator = ({ isCreating }) => {
  const navigate = useNavigate()
  const {
    session: { user },
  } = useContext(AuthContext)
  const { data, loading } = useApi(() => getUser(user.id), [user])
  const { data: token } = useApi(
    () => fetchToken(data?.avatars?.readyplayer_user_id, 'mad-platform'),
    [data]
  )

  const handleAvatar = async (data) => {
    await upsertAvatar(user.id, data.url, data.userId, data.avatarId)
    if (isCreating) {
      navigate('/meet-your-avatar')
    } else {
      navigate('/')
    }
  }

  return (
    <div className="w-full mx-auto">
      {loading || !data ? (
        <LoadingOverlay />
      ) : (
        <Avatar
          handleAvatar={handleAvatar}
          token={token}
          avatarId={data.avatars?.readyplayer_avatar_id}
        />
      )}
    </div>
  )
}

export default AvatarCreator
